import { Fragment, useEffect, useRef, useState } from "react";
import {
  addCommodities,
  editCommodities,
  getCommodities,
} from "../../homepurchase.service";
import { useMediaQuery } from "react-responsive";
import {
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { formatDate } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { NumericFormat } from "react-number-format";
import { formatNumber } from "app/utils/utility.service";
import { confirmDialog } from "primereact/confirmdialog";
import moment from "moment";

const initialState = {
  commodities_name: "",
  purchase_date: "",
  qty_owned: "",
  purchasePrice: "",
  //current_price: "",
  //percentage_change: "",
  //gain_loss: "",
  projected_growth: "",
};

const AddCommodities = ({
  commoditiesModal,
  handleAddCommoditiesModal,
  setComDetails,
  comDetails,
  title,
  values,
  setValues,
  pdate
}) => {
  const toast = useRef();
  const { data, setData } = useOutletContext(); // Access Parent's state
  const [selectedId, setSelectedId] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [searchParams] = useSearchParams();
  const sessionValues = getSessionUserInformation();
  const [valuesModified, setValuesModified] = useState(false);
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState([]);
  const [label, setLabel] = useState("");
  const onHide = (data) => {
    setFormSubmitted(false);
    setValues(initialState);
    handleAddCommoditiesModal(false);
    // Only update data if valid data is provided
    if (data) {
      // Check if record with same ID already exists
      const existingRecord = comDetails.find(item => item.id === data.id);
      if (!existingRecord) {

      setData({
        list: data ? [...comDetails, data] : comDetails,
        purchasePrice: values?.purchasePrice,
        appreciation: values?.projected_growth,
        addressOne:values?.commodities_name,
        dataPresent: true,
      });
    }
  }
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const validateInput = () => {
    if (
      !values.commodities_name ||
      !values.purchase_date ||
      !values.qty_owned ||
      !values.purchasePrice ||
      //!values.current_price ||
      !values.projected_growth
    ) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    let label = title.indexOf("Add") > -1 ? "Add" : "Save";
    setLabel(label);

    const fetchCommoditiesDetails = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await getCommodities(userId);
      if (list) {
        setIsLoading(false);
        if (list) {
          list.map((li, index) => (li.srNo = index + 1));
        }
        setPropertyDetails(list);
        if (title.indexOf("Add") !== -1) {
          setSelectedId(list[0]?.id);
        }
        if(label === 'Save')
        setData({
          purchasePrice: values?.purchasePrice,
          appreciation: values?.projected_growth,
          addressOne:values?.commodities_name,
          dataPresent: true,
        });
      }
    };

    fetchCommoditiesDetails();
  }, [commoditiesModal]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value   
    });
  };
  
  const handleInputChangeNumber = (name, e) => {
    let value = e.target.value.replace(/[$,]/g, "");
    if(name === 'projected_growth' && value.replace('%', '').trim() !== values.projected_growth ) {
      setValuesModified(true);
    } else {
      setValuesModified(false);
    }
    setValues({
      ...values,
      [name]: parseFloat(value)
    });
  };

  // Function to handle input changes and calculations
  const handleChange = (name, value) => {
    
    const newValues = { ...values, [name]: value };
    
   /* if(name === 'purchasePrice') {
      if(value.replace('%', '').trim() !== values.purchasePrice ) {
        setValuesModified(true);
      } else {
        setValuesModified(false);
      }
    }
    if(name === 'qty_owned') {

      if(value !== values.qty_owned) {
        setValuesModified(true);
      } else {
        setValuesModified(false);
      }
    }*/
    // Convert to numbers safely
    const quantity = parseFloat(newValues.qty_owned) || 0;
    const purchasePrice = parseFloat(newValues.purchasePrice) || 0;
    //const currentPrice = parseFloat(newValues.current_price) || 0;

    // Perform calculations
    newValues.inv_value = quantity * purchasePrice;
   // newValues.current_value = quantity * currentPrice;
   // newValues.percentage_change =
    //  purchasePrice > 0 ? (((currentPrice - purchasePrice) / purchasePrice) * 100).toFixed(2) : 0;
    //newValues.gain_loss =  currentPrice - purchasePrice;

    // Set new state only if values have changed
    setValues(newValues);
  };
  const confirmAction = (message, header = 'Confirm') => {
    return new Promise((resolve) => {
          confirmDialog({
            message: message,
            header: 'Confirmation',
            acceptClassName: 'p-button-raised p-button-lg',
            rejectClassName: 'p-button-raised p-button-warning p-button-lg',
            accept: () => {
  
              //changeProjectedValue = true;
              resolve(true)
            },
            reject: () => {
             // changeProjectedValue = false;
  
              resolve(false);
            }
            });
          });
    }

    const handleDateChange = (e) => {
       let purchase_date = e.target.value;
        const momentDate = moment(purchase_date, 'DD/MM/YYYY', true);
        let fixedDate;
        if (momentDate.isValid()) {
          // Use moment with time set to noon to prevent timezone issues
          fixedDate = moment(purchase_date).format('YYYY-MM-DD');
        }
     
       /* if(moment(purchase_date).format('YYYY-MM-DD') !== moment(pdate).format('YYYY-MM-DD'))
          setValuesModified(true);
        else
          setValuesModified(false);*/
        setValues({
          ...values,
          purchase_date: purchase_date
            ? fixedDate
            : null,
        })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    let changeProjectedValue = true;
  
    if(title.indexOf("Add") === -1) {
      /*if(valuesModified) {
        changeProjectedValue = await confirmAction("Editing this value will cause a change in value in Accounts Section. Do you want to proceed?");
      }*/
    }

    if (!validateInput()) {
      return false;
    }

    let details;
    setIsLoading(true);
    let msg = "";
    //let percentageChange =
    //  ((values?.current_price - values?.purchasePrice) /
    //    values?.purchasePrice) *
    //  100;
    //let gain = values?.current_price - values?.purchasePrice;
    let inv_value = values?.qty_owned * values?.purchasePrice;
    //let current_value = values?.qty_owned * values?.current_price;

    let req = values;
   // req.percentage_change = percentageChange.toFixed(2);
   // req.gain_loss = gain;
    req.inv_value = inv_value;
   // req.current_value = current_value;
    req.valuesModified = changeProjectedValue;
   
    if (title.indexOf("Add") !== -1) {
      details = await addCommodities(req);
      if(!!details?.data)
      setComDetails([...comDetails, details?.data]); // Add to list
      setData({
        list:[...comDetails, details?.data],
        purchasePrice: values?.purchasePrice,
        appreciation: values?.projected_growth,
        addressOne:values?.commodities_name,
        dataPresent: true,
      });
      msg = "Commodities details added successfully";
    } else {
      details = await editCommodities(req, values?.id);
      if(!!details?.data) {
      setComDetails(
        comDetails.map((item) => (item.id === details?.data.id ? details?.data : item))
      ); //Update list
      setData({
        list:comDetails.map((item) => (item.id === details?.data.id ? details?.data : item)),
        purchasePrice: values?.purchasePrice,
        appreciation: values?.projected_growth,
        addressOne:values?.commodities_name,
        dataPresent: true,
      });
    }
      msg = "Commodities details updated successfully";
    }
    if (!!details?.data) {
      showSuccess(msg);
    
      setTimeout(() => {
        onHide(details?.data);
      }, 1000);
    } else {
      showError(details?.message);
    }
    setIsLoading(false);
  };
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-3"></div>
          <div
            className={`${
              isDesktopOrLaptop ? "col-7" : "col-12 text-align-center"
            }`}
          >
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
            <Button
              type="submit"
              label={label}
              className={`p-button-raised p-button-warning p-button-lg  ${
                isDesktopOrLaptop ? "" : "ml-4"
              }`}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header="Commodities Information"
      visible={commoditiesModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
       style={{ width: "35vw", maxHeight: "90vh" }}
      contentStyle={{ height: "63vh", overflowY: "auto" }}
  
      footer={renderFooter()}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align">
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid">
              
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Commodities Name</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <InputText
                        className="vw-inputtext-with-border"
                        autoComplete="off"
                        required={true}
                        name="commodities_name"
                        value={values?.commodities_name}
                        onChange={handleInputChange}
                      />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.commodities_name && (
                      <small className="p-error">
                        Please enter commodity name
                      </small>
                    )}
                  </div>
                </div>
              </div>

             
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Purchase Date</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Calendar
                      id="buttondisplay"
                      maxDate={new Date()}
                      onChange={handleDateChange}
                      showIcon
                      dateFormat="mm/dd/yy"
                         value={
                        values?.purchase_date
                          ? new Date(formatDate(values?.purchase_date))
                          : null
                      }
                      
             
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.purchase_date && (
                      <small className="p-error">Please enter date</small>
                    )}
                  </div>
                </div>
              </div>

             
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Quantity Owned</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      name="qty_owned"
                      decimalScale={0}
                      allowNegative={false}
                      onValueChange={(vals) => handleChange("qty_owned", vals.value)}
                      value={values?.qty_owned}
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.qty_owned && (
                      <small className="p-error">
                        Please enter quantity owned
                      </small>
                    )}
                  </div>
                </div>
              </div>

            
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Purchase Price</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      prefix="$ "
                      name="purchasePrice"
                      decimalScale={2}
                      allowNegative={false}
                      onValueChange={(vals) => handleChange("purchasePrice", vals.value)}
                      value={values?.purchasePrice}
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.purchasePrice && (
                      <small className="p-error">
                        Please enter purchase price
                      </small>
                    )}
                  </div>
                </div>
              </div>

              
              {/*<div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Current Price </label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      prefix="$ "
                      name="current_price"
                      decimalScale={2}
                      allowNegative={false}
                      value={values?.current_price}
                      onValueChange={(vals) => handleChange("current_price", vals.value)}
                    
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.current_price && (
                      <small className="p-error">
                        Please enter current price
                      </small>
                    )}
                  </div>
                </div>
              </div>
              */}
           
                <Fragment>
                 
                  <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                    <label className="mt-3">Investment Value</label>
                  </div>
                  <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                    <div className="field">
                      <div className="p-inputgroup">
                        <span className="p-float-label">
                          <InputText
                            className="input-field"
                            style={{ width: "100%" }}
                            disabled={true}
                            thousandSeparator=","
                            autoComplete="off"
                            required={true}
                            prefix="$ "
                            name="inv_value"
                            decimalScale={0}
                            allowNegative={false}
                            value={values?.inv_value !== undefined && values?.inv_value !== null
                              ? `$ ${formatNumber(values.inv_value)}`
                              : " "}
                          />
                        </span>
                      </div>
                     
                    </div>
                  </div>

                 {/*
                  <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                    <label className="mt-3">Current Value</label>
                  </div>
                  <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                    <div className="field">
                      <div className="p-inputgroup">
                        <InputText
                          className="input-field"
                          disabled={true}
                          style={{ width: "100%" }}
                          thousandSeparator=","
                          autoComplete="off"
                          required={true}
                          prefix="$ "
                          name="current_value"
                          decimalScale={0}
                          allowNegative={false}
                          value={values?.current_value !== undefined && values?.current_value !== null
                            ? `$ ${formatNumber(values.current_value)}`
                            : " "}
                        />
                      </div>
                   
                    </div>
                  </div>

                  
                  <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                    <label className="mt-3">Percentage Change</label>
                  </div>
                  <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                    <div className="field">
                      <div className="p-inputgroup">
                        <InputText
                          className="vw-inputtext-with-border"
                          autoComplete="off"
                          required={true}
                          name="percentage_change"
                          value={isNaN(values?.percentage_change) || values?.percentage_change === undefined
                            ? ""
                            : formatNumber(values.percentage_change) + " %"
                          }
                          disabled={true}
                         
                        />
                      </div>
                    </div>
                  </div>

                 
                  <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                    <label className="mt-3">Gain/ Loss</label>
                  </div>
                  <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                    <div className="field">
                      <div className="p-inputgroup">
                        <InputText
                          className="vw-inputtext-with-border"
                          autoComplete="off"
                          required={true}
                          name="gain_loss"
                          disabled={true}
                          value={values?.gain_loss !== undefined && values?.gain_loss !== null
                            ? `$ ${formatNumber(values.gain_loss)}`
                            : " "}
                         
                        />
                      </div>
                    </div>
                  </div>*/}
                </Fragment>
              
            
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Projected Growth</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <span className="p-float-label">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      name="projected_growth"
                      decimalScale={2}
                      allowNegative={false}
                      onBlur={(e) => {
                        handleInputChangeNumber("projected_growth", e);
                      }}
                      value={values?.projected_growth}
                    />
                  </span>
                  <div className="text-align-left">
                    {formSubmitted && !values?.projected_growth && (
                      <small className="p-error">
                        Please enter projected growth
                      </small>
                    )}
                  </div>
                </div>
              </div>

              {/* Annual Income */}
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Annual Income</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <span className="p-float-label">
                    <NumericFormat
                      className="input-field"
                      style={{ width: "100%" }}
                      thousandSeparator=","
                      autoComplete="off"
                      required={true}
                      suffix=" %"
                      name="annualIncome"
                      decimalScale={2}
                      allowNegative={false}
                      onBlur={(e) => {
                        handleInputChangeNumber("annualIncome", e);
                      }}
                      value={values?.annualIncome}
                    />
                  </span>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default AddCommodities;
